<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-排班-添加
    -->
    <el-dialog
    title="添加排班"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加排班</div>
      
      <el-form-item label="选择老师" prop="name" >
      <div>{{ form.coc_name }}</div>
    
      <el-button @click="chooseTeacher" icon="el-icon-plus">选择老师</el-button>
    </el-form-item>
    <el-form-item label="标题" prop="term">
      <el-input v-model="form.term" placeholder="请输入标题" class="max-w460"></el-input>
      <div>例子：2024上半年学期</div>
    </el-form-item>

      <el-form-item label="名称" prop="name"><el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="介绍" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入介绍" class="max-w460"></el-input>
      </el-form-item>

  
      <el-form-item label="年份" prop="remark">
        <el-date-picker
                        style="width: 150px;"
                          size="small"
                          type="year"
                          v-model="form.datea"
                          value-format="yyyy"
    
                        ></el-date-picker>
      </el-form-item>


  

      <el-form-item label="类型" prop="remark">
                <template slot-scope="scope">
                  <div class="product-info">
                    <el-select v-model="form.type" filterable placeholder="请选择" >
                      <el-option  label="正课(单词)"  :value="1"></el-option>
                      <el-option  label="正课(语法)"  :value="2"></el-option>
                      <el-option  label="复习课" :value="3"></el-option>
           
                  </el-select>
                  </div>
                </template>
              </el-form-item>

      <el-form-item label="是否开启">
          <el-radio-group v-model="form.status">
           
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">未开启</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="是否完成" >
          <el-radio-group v-model="form.fstatus">
            <el-radio :label="0">进行中</el-radio>
            <el-radio :label="1">已完成</el-radio>
          </el-radio-group>
        </el-form-item> -->


        <template >
            <div class="common-form mt16">设置时间段</div>

            <el-form-item>
             
             <el-button icon="el-icon" type="primary" @click.stop="add">添加时间段</el-button>
           </el-form-item>


        <el-form-item label="时间段">
          <div class="table-wrap" style="margin-top: 15px;" >
            <el-table size="small" :data="form.time" border style="width: 100%" >
              <el-table-column prop="product_name" label="序号" width="50">
                <template slot-scope="scope">
                  <div class="product-info">
                    {{ scope.$index +1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="product_no" label="周几" width="120">
                <template slot-scope="scope">
                  <div class="product-info">
                   <el-select v-model="scope.row.week"  size="small" placeholder="请选择">
                      <el-option :value="1" label="周一">周一</el-option>
                      <el-option :value="2" label="周二">周二</el-option>
                      <el-option :value="3" label="周三">周三</el-option>
                      <el-option :value="4" label="周四">周四</el-option>
                      <el-option :value="5" label="周五">周五</el-option>
                      <el-option :value="6" label="周六">周六</el-option>
                      <el-option :value="7" label="周日">周日</el-option>
                   </el-select>
                  </div>
                </template>
              </el-table-column>


         


              <el-table-column prop="product_no" label="时间段一" width="200">
                <template slot-scope="scope">
                  <div class="product-info">
                    <div class="block">
                 
                        <el-time-picker
                        style="width: 150px;"
                          size="small"
                          v-model="scope.row.time_start"
                          value-format="HH:mm"
                        ></el-time-picker>
                      </div>
                  </div>
                </template>
              </el-table-column>


              <el-table-column prop="product_no" label="时间段二" width="200">
                <template slot-scope="scope">
                  <div class="product-info">
                    <div class="block">
                    
                      <el-time-picker
                      style="width: 150px;"
                        size="small"
                        v-model="scope.row.time_end"
                        value-format="HH:mm"
                      ></el-time-picker>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="product_no" >
                <template slot-scope="scope">
                  <div class="product-info">
                    <div class="block">
                      <el-button  size="small" type="primary" @click="copy(scope.$index)" :loading="loading">复制</el-button>
                   
                      <el-button v-if="scope.$index != 0" size="small" type="primary" @click="del(scope.$index)" :loading="loading">删除</el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
          
       
            </el-table>
          </div>
        </el-form-item>

        
        </template>
  

    
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

  <Staffs :is_open="is_coc"   @close="closeServiceFunc" :multi="multi"></Staffs>
</el-dialog>
  
</template>

<script>
  import WorkforceApi from '@/api/workforce.js';
  import Staffs from '@/components/user/Staff';
export default {
  components: {
    Staffs
  },
  data() {
    return {
 
      /*form表单数据*/
      form: {
        coc_id:'',
        coc_name:"",
        name: '',
        remark:"",
        term:"",
        status:1,
        fstatus:0,
        datea:"",
        type:1,
        time:[
          {
            id:1,
            week:1,
            type:1,
            time_start:"9:00",
            time_end:"10:00",
            is_book:0,
            user:{}
          }
      ],
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入排班名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      is_coc:false,
      multi:false,
      
      multipleSelection:[]
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
      copy(index){
        this.form.time.push({
          id:this.form.time[this.form.time.length - 1].id+1,
          week: this.form.time[index].week,
          type: this.form.time[index].type,
          time_start:this.form.time[index].time_start,
          time_end:this.form.time[index].time_end,
          is_book:0,
          user:{}
        });
      },
      del(index){
        this.form.time.splice(index, 1);
      },
      add(){
          this.form.time.push({
          id:this.form.time[this.form.time.length - 1].id+1,
          week:1,
          type:1,
          time_start:"9:00",
          time_end:"10:00",
          is_book:0,
          user:{}
        });
      },
    //    /*监听复选按钮选中事件*/
    //    tableCurrentChange(val) {
    //   console.log(val)
    //   this.multipleSelection = val;
    // },
    //   /*是否可以勾选*/
    //   selectableFunc(e) {
    //   if (typeof e.noChoose !== 'boolean') {
    //     return true;
    //   }
    //   return e.noChoose;
    // },
    closeServiceFunc(e){
        console.log("e",e)
        this.form.coc_id = e.params.coc_id
        this.form.coc_name = e.params.name
        this.is_coc = false
 
      },
    chooseTeacher(){//选择教师
      this.is_coc = true;
      console.log(this.is_coc)

    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
         
          if(Array.isArray(form.time)){
             form.time = JSON.stringify(form.time);
          }
          WorkforceApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style lang='scss'>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.noneSecond{
 
    //调整样式
    .el-time-spinner {
      width: 150%;
      white-space: nowrap;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/plus/workforce/workforce/part/add.vue